import _ from '@app/utils.js'

_.onElementReady('.page-node-type-download .secondary-menu', menu => {
  const items = document.querySelectorAll('[data-category]')

  function onFilter(category) {
    menu.querySelector('a.active')?.classList.remove('active')
    menu.querySelector('a[href="#'+category+'"]').classList.add('active')
    if(category === 'ALL') {
      items.forEach(item => item.classList.remove('hidden'))
    }
    else {
      for(const item of items) {
        item.classList.toggle('hidden', item.dataset.category !== category)
      }
    }
  }

  menu.querySelectorAll('a').forEach(link => {
    const href = link.getAttribute('href')
    if(href.startsWith('#')) {
      const category = href.slice(1)
      link.addEventListener('click', e => {
        onFilter(category)
      })
    }
  })


  onFilter(document.URL.split('#')[1] ?? 'ALL')

  window.addEventListener('hashchange', () => {
    onFilter(window.location.hash.slice(1) || 'ALL')
  })

  const drawer = menu.closest('.filters-drawer')
  if(drawer) {
    const setDrawerOpen = open => {
      drawer.classList.toggle('open', open)
      document.body.classList.toggle('filters-drawer-open', open)
    }
    document.querySelector('[data-filters-open]')?.addEventListener('click', () => setDrawerOpen(true))
    drawer.querySelectorAll('[data-filters-close]').forEach(btn => btn.addEventListener('click', () => setDrawerOpen(false)))
    menu.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => setDrawerOpen(false)))
  }
})
